import { useQuery } from '@hooks/reactQuery';

import { getGNodeBConfigParameters } from '@api/gNodeBConfigParameters';

import { extractQueryParams } from '@utils/common';

import { IId } from '@interfaces/common/common';
import { IGNodeBConfigParameters, IGNodeBConfigParameterWithComment } from '@interfaces/crowdcell/gNodeBConfig';

import { GNODEB_CONFIG_PARAMETERS } from '@constants/queryKeys';

interface IUseGNodeBConfigParameters {
	isRestart?: boolean;
	frequency?: string;
	gNodeBConfigParameters: IGNodeBConfigParameterWithComment[];
	isLoadingGNodeBConfigParameters: boolean;
}

export const useQueryGNodeBConfigParameters = ({ id }: IId): IUseGNodeBConfigParameters => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<IGNodeBConfigParameters>({
		queryKey: [GNODEB_CONFIG_PARAMETERS, id],
		queryFn: extractQueryParams(getGNodeBConfigParameters),
		enabled: [id],
		refetchOnWindowFocus: false,
	});

	return {
		isRestart: data?.isRestart,
		frequency: data?.frequency,
		gNodeBConfigParameters: data?.parameters || [],
		isLoadingGNodeBConfigParameters: isLoading || isFetching,
	};
};
